import { CaretUpDown } from '@phosphor-icons/react';

export default CaretUpDown;
